import { FormGroup } from '@angular/forms';
import { Leg } from '@approot/models';
import { optionsChangeHandler } from './leg.utilities';
import {
  getAttributeControlFromKey,
  getAllAttributeOptions
} from './leg-attribute-utilities';

export function resetTargetProfitUnitNonDigital(
  form: FormGroup,
  leg: Leg
): void {
  const tpuControl = form.get('targetProfitUnit');
  const currencyControl = form.get('currency');
  if (tpuControl && currencyControl) {
    const options = [...getAllAttributeOptions('currency', leg), 'Spot'];

    optionsChangeHandler(
      form,
      leg,
      'targetProfitUnit',
      options,
      options.includes(tpuControl.value) ? null : 'Spot'
    );
  }
}

export function targetProfitUnitChange(
  val: string,
  leg: Leg,
  form: FormGroup
): void {
  let targetProfitVal = getAttributeControlFromKey(
    'targetProfit',
    leg.attributesAsFormControls
  ).validator;

  if (val === 'Spot') {
    if (!targetProfitVal.includes('decimalNumber')) targetProfitVal = [];
    targetProfitVal.push('decimalNumber');
  }

  if (val !== 'None' && val !== 'Common Currency' && val !== 'Spot') {
    if (
      (!targetProfitVal.includes('numericShorthand') &&
        !targetProfitVal.includes('numericDisplay')) ||
      targetProfitVal.includes('decimalNumber')
    ) {
      targetProfitVal.push('numericShorthand');
      targetProfitVal.push('numericDisplay');
    }
  }
  targetProfitTypeOnUnitChange(val, form, leg);
}

function targetProfitTypeOnUnitChange(
  val: string,
  form: FormGroup,
  leg: Leg
): void {
  const targetProfit = form.get('targetProfit');
  const targetProfitType = form.get('targetProfitType');
  if (
    form.get('targetProfitUnit') &&
    targetProfitType &&
    targetProfitType.value !== 'Digital'
  ) {
    if (val === 'Spot') {
      // Add Configuration for KO, TP Adjustments, Unit if "None" is selected
      targetProfit.updateValueAndValidity(); // Update TP when TP Unit value changes
    } else {
      if (val === 'None') {
        optionsChangeHandler(
          form,
          leg,
          'targetProfitAdjustmentType',
          ['None'],
          'None'
        );
      }
    }
  }
}

export function targetProfitTypeFrozenChooserChange(
  leg: Leg,
  form: FormGroup
): void {
  const tPUnit = form.get('targetProfitUnit');
  if (
    leg.productType === 'choosertpf' ||
    leg.productType === 'frozenchoosertpf' ||
    leg.productType === 'chooserpivottpf'
  ) {
    // For Choosers, TP Unit should always be 'Common Currency'
    if (form.get('targetProfitType')) {
      if (tPUnit) {
        optionsChangeHandler(
          // Changes to 'Common Currency' once the TP Type has been selected
          form,
          leg,
          'targetProfitUnit',
          ['Common Currency'],
          'Common Currency'
        );
      }
    }
  }
}

export function targetProfitTypeNotDigital(form: FormGroup, leg: Leg): void {
  // if NOT Digital
  let koType = form.get('koType');
  if (koType) {
    optionsChangeHandler(
      form,
      leg,
      'koType',
      ['Exact', 'FullKnockOut', 'KeepLastFlow'],
      ''
    );
  }
  resetTargetProfitUnitNonDigital(form, leg);
}

export function targetProfitTypeDigital(leg: Leg, form: FormGroup): void {
  // Checks if the value is "Digital"
  const targetProfit = form.get('targetProfit');
  if (targetProfit) {
    // Checks if target profit exists
    let targetProfitVal = getAttributeControlFromKey(
      'targetProfit',
      leg.attributesAsFormControls
    ).validator; // Set Validator for this field as a variable
    if (
      // !targetProfitVal.includes('positiveInteger') &&
      !targetProfitVal.includes('numericShorthand') &&
      !targetProfitVal.includes('numericDisplay')
    ) {
      // Check if the field does not contains the validator for "positive integer"
      // targetProfitVal.push('positiveInteger'); // Set the validator to this field if true
      targetProfitVal.push('numericShorthand'); // Add numeric shorthand
      targetProfitVal.push('numericDisplay');
    }
  }

  if (
    form.get('targetProfitUnit') ||
    form.get('koType') ||
    form.get('targetProfitAdjustmentType')
  ) {
    //Checks if the target profit unit exists
    //Checks if Knock-Out Type exists
    //Checks if Target Profit Adjustment exists
    optionsChangeHandler(form, leg, 'targetProfitUnit', ['None'], 'None');

    optionsChangeHandler(
      form,
      leg,
      'koType',
      ['FullKnockOut', 'KeepLastFlow'],
      ''
    );
    // c. Knock-Out Type: should be 'FullKnockOut' or 'KeepLastFlow' new dropdown to be set

    optionsChangeHandler(
      form,
      leg,
      'targetProfitAdjustmentType',
      ['None'],
      'None'
    ); // Sets value of Target Profit Adjustment to "None"
  }
}
